import React from 'react';
import type {QueryFilterAdapterModel, QueryFilterAdapterProps} from '@igp/shared/components/filter';
import {withQueryFilter} from '@igp/shared/components/filter';

import type {
    AgentLevelReportV2FilterModel,
    AgentLevelReportV2FilterName,
    AgentLevelReportV2ServerFilterKeys,
    AgentLevelReportV2ServerTextFilterKeys,
} from '../types';

import {AgentLevelReportV2Filters} from './Filters';

type AgentLevelReportV2QueryFilterAdapterProps = QueryFilterAdapterProps<
    AgentLevelReportV2ServerFilterKeys,
    AgentLevelReportV2FilterName,
    AgentLevelReportV2ServerTextFilterKeys
>;
function AgentLevelReportV2QueryFilterAdapter({model, onChange, ...props}: AgentLevelReportV2QueryFilterAdapterProps) {
    const filterModel: AgentLevelReportV2FilterModel = {
        text: model?.text ? {...model.text, option: model?.text?.option} : null,
        weekStartDate: {
            from: model?.['week_start_date_ts.from'] as number,
            to: model?.['week_start_date_ts.to'] as number,
        },
        dailyAggregationRange: {
            from: model?.['daily_aggregation_range.from'] as number,
            to: model?.['daily_aggregation_range.to'] as number,
        },
        type: model?.type === 'daily' ? 'daily' : 'weekly',
    };

    function handleChange(model: AgentLevelReportV2FilterModel) {
        const result: QueryFilterAdapterModel<AgentLevelReportV2ServerFilterKeys, AgentLevelReportV2ServerTextFilterKeys> = {
            text: model?.text ? {...model?.text, option: model?.text?.option} : undefined,
            'week_start_date_ts.from': model?.weekStartDate?.from,
            'week_start_date_ts.to': model?.weekStartDate?.to,
            'daily_aggregation_range.from': model?.dailyAggregationRange?.from,
            'daily_aggregation_range.to': model?.dailyAggregationRange?.to,
            type: model?.type === 'daily' ? 'daily' : 'weekly',
        };

        onChange(result);
    }

    return <AgentLevelReportV2Filters model={filterModel} onChange={handleChange} {...props} />;
}

export const AgentLevelReportV2QueryFilters = withQueryFilter<
    AgentLevelReportV2ServerFilterKeys,
    AgentLevelReportV2FilterName,
    AgentLevelReportV2ServerTextFilterKeys
>(AgentLevelReportV2QueryFilterAdapter, {
    agentUidUsername: ['agent_uid_username', 'agent_uid', 'agent_username'],
    agentUid: ['agent_uid'],
});
